import httpClient from './httpClient';

const END_POINT = '/api/type_packs';
const getAllTypePacks = (filterList = null, sort = null) => {
    let typePackApi = END_POINT;
    typePackApi += filterList != '' ? '?' + filterList : '';
    typePackApi += sort != '' ? '?' + sort : '';
    return httpClient.get(typePackApi);
};
const updateTypePack = (id, typePack) => httpClient.put(END_POINT + '/' + id, typePack);
const updateAllTypePack = allTypePack => httpClient.post(END_POINT + '/updateAllTypePack', allTypePack);
const deleteTypePack = id => httpClient.delete(END_POINT + '/' + id);
const addTypePack = typePack => httpClient.post(END_POINT, typePack);

export {
    getAllTypePacks,
    updateTypePack,
    deleteTypePack,
    addTypePack,
    updateAllTypePack
};
